export default __webpack_public_path__ + "static/media/url-shortner.ea3e543d.png";